// Module
var code = "<!-- ko if: channel -->\n<span class=\"channel-icon__icon\">\n  <svg-icon params=\"name: 'channel-' + channel.id\" data-bind=\"class: 'f-color-channel-' + channel.id\"></svg-icon>\n</span>\n<div class=\"channel-icon__repeats\" data-bind=\"text: repeats\"></div>\n<!-- /ko -->\n";
// Exports
module.exports = code;